// extracted by mini-css-extract-plugin
export default {"date":"date-range_date__44d5m","item":"date-range_item__byzm7"};